<template>
  <div>
    <b-alert variant="info" show class="mb-2">
      Selecciona los días de atención y configura el horario para cada uno.
    </b-alert>

    <b-card
      v-for="day in days"
      :key="day.key"
      class="mb-1"
    >
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <b-form-checkbox
          :id="`horario-${day.key}`"
          v-model="localSchedule[day.key].enabled"
        >
          {{ day.label }}
        </b-form-checkbox>

        <div
          v-if="localSchedule[day.key].enabled"
          class="d-flex align-items-center flex-wrap horario-inputs"
        >
          <div class="d-flex align-items-center mr-2">
            <label class="mb-0 mr-1">Desde:</label>
            <flat-pickr
              v-model="localSchedule[day.key].start"
              :config="timePickerConfig"
              class="form-control"
            />
          </div>
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-1">Hasta:</label>
            <flat-pickr
              v-model="localSchedule[day.key].end"
              :config="timePickerConfig"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </b-card>

    <b-row class="mt-2">
      <b-col md="4" sm="6">
        <b-form-group label="Turnos (minutos)">
          <b-form-select
            :options="turnOptions"
            v-model="localTurno"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BootstrapVue } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

const defaultSchedule = () => ({
  monday: { enabled: false, start: null, end: null },
  tuesday: { enabled: false, start: null, end: null },
  wednesday: { enabled: false, start: null, end: null },
  thursday: { enabled: false, start: null, end: null },
  friday: { enabled: false, start: null, end: null },
  saturday: { enabled: false, start: null, end: null },
})

const cloneSchedule = source => {
  const base = defaultSchedule()
  return Object.keys(base).reduce((acc, key) => {
    const value = source && source[key] ? source[key] : {}
    acc[key] = {
      enabled: Boolean(value.enabled),
      start: value.start || null,
      end: value.end || null,
    }
    return acc
  }, {})
}

export default {
  name: 'DoctorHorarioForm',
  components: {
    ...BootstrapVue.components,
    flatPickr,
  },
  props: {
    value: {
      type: Object,
      default: () => defaultSchedule(),
    },
    turno: {
      type: [Number, String],
      default: 20,
    },
  },
  data() {
    return {
      localSchedule: cloneSchedule(this.value),
      localTurno: Number(this.turno) || 20,
      syncingSchedule: false,
      syncingTurno: false,
      days: [
        { key: 'monday', label: 'Lunes', value: 1 },
        { key: 'tuesday', label: 'Martes', value: 2 },
        { key: 'wednesday', label: 'Miércoles', value: 3 },
        { key: 'thursday', label: 'Jueves', value: 4 },
        { key: 'friday', label: 'Viernes', value: 5 },
        { key: 'saturday', label: 'Sábado', value: 6 },
      ],
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
      turnOptions: [
        { value: 10, text: '10 minutos' },
        { value: 20, text: '20 minutos' },
        { value: 30, text: '30 minutos' },
        { value: 40, text: '40 minutos' },
      ],
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        this.syncingSchedule = true
        this.localSchedule = cloneSchedule(newVal)
        this.$nextTick(() => { this.syncingSchedule = false })
      },
    },
    turno(newVal) {
      this.syncingTurno = true
      this.localTurno = Number(newVal) || 20
      this.$nextTick(() => { this.syncingTurno = false })
    },
    localSchedule: {
      deep: true,
      handler() {
        if (this.syncingSchedule) return
        this.$emit('input', cloneSchedule(this.localSchedule))
      },
    },
    localTurno(newVal) {
      if (this.syncingTurno) return
      this.$emit('update:turno', Number(newVal))
    },
  },
}
</script>

<style scoped>
.horario-inputs .form-control {
  min-width: 120px;
}
</style>
